<template>
  <div>
    <transition name="fade">
      <div v-show="graphic">
        <h2 class="sm:text-2xl ml-60 font-medium title-font mb-2 text-gray-700">
          Here your graphic saldo's
        </h2>
        <div class="animate-pulse flex mx-auto my-2 items-center w-1/2">
          <trend
            :data="dataSaldo"
            :gradientDirection="top"
            :gradient="['#6fa8dc', '#ff93df', '#3a86ff']"
            :padding="8"
            :radius="8"
            :stroke-width="1"
            :stroke-linecap="butt"
            auto-draw
            smooth
          >
          </trend>
        </div>
      </div>
    </transition>
    <div class="flex justify-around my-2 items-center">
      <h3 class="sm:text-2xl ml-20 font-medium title-font mb-2 text-gray-700">
        All your trasanctions
      </h3>
      <div class="mr-20 block">
        <a
          href=""
          class="animate-pulse px-5 py-2 font-semibold text-gray-100 transition-colors duration-200 transform bg-pink-400 rounded-md hover:bg-pink-700"
          @click.prevent="addNewTransactions"
          >Add New Transactions</a
        >
      </div>
    </div>
    <transition name="fade">
      <div
        class="flex mx-auto w-1/2 h-14 rounded-md text-white bg-green-500"
        v-show="success"
      >
        <div
          class="container flex items-center justify-between px-6 py-4 mx-auto"
        >
          <div class="flex">
            <svg viewBox="0 0 40 40" class="w-6 h-6 fill-current">
              <path
                d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z"
              ></path>
            </svg>

            <p class="mx-3">Success add wallet</p>
          </div>

          <button
            @click.prevent="close"
            class="p-1 transition-colors duration-200 transform rounded-md hover:bg-opacity-25 hover:bg-gray-600 focus:outline-none"
          >
            <svg
              class="w-5 h-5"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 18L18 6M6 6L18 18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div
        v-show="error"
        class="flex w-full max-w-sm mx-auto overflow-hidden bg-white rounded-lg shadow-md dark:bg-gray-800"
      >
        <div class="flex items-center justify-center w-12 bg-yellow-400">
          <svg
            class="w-6 h-6 text-white fill-current"
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM21.6667 28.3333H18.3334V25H21.6667V28.3333ZM21.6667 21.6666H18.3334V11.6666H21.6667V21.6666Z"
            />
          </svg>
        </div>

        <div class="px-4 py-2 -mx-3">
          <div class="mx-3">
            <span class="font-semibold text-yellow-400 dark:text-yellow-300"
              >Warning</span
            >
            <p class="text-sm text-gray-600 dark:text-gray-200">
              Please insert all input :'(
            </p>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <section
        v-show="showForm"
        class="mt-4 max-w-4xl p-6 mx-auto bg-white rounded-md shadow-md dark:bg-gray-800"
      >
        <h2
          class="text-lg font-semibold text-gray-700 capitalize dark:text-white"
        >
          Add Transactions
        </h2>
        <form>
          <div class="mt-2 flex items-center mx-auto">
            <label class="text-gray-700 dark:text-gray-200" for="date"
              >Transactions Type</label
            >
            <label class="ml-10 inline-flex items-center">
              <input
                type="radio"
                class="form-radio"
                v-model="TransactionsType"
                value="income"
              />
              <span class="ml-2">Income</span>
            </label>
            <label class="inline-flex items-center ml-6">
              <input
                type="radio"
                class="form-radio"
                v-model="TransactionsType"
                value="outcome"
              />
              <span class="ml-2">Outcome</span>
            </label>
          </div>
          <div class="grid grid-cols-1 gap-6 mt-4 sm:grid-cols-2">
            <div>
              <label class="text-gray-700 dark:text-gray-200" for="date"
                >Date</label
              >
              <input
                id="date"
                required
                type="date"
                v-model="date"
                class="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
              />
            </div>

            <div>
              <label class="text-gray-700 dark:text-gray-200" for="emailAddress"
                >Amount</label
              >
              <input
                id="emailAddress"
                type="number"
                v-model="amount"
                class="block w-full px-4 py-2 mt-2 text-gray-700 bg-white border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-500 dark:focus:border-blue-500 focus:outline-none focus:ring"
              />
            </div>

            <div>
              <label class="text-gray-700 dark:text-gray-200" for="emailAddress"
                >Wallet</label
              >
              <!-- <ListWalletName></ListWalletName> -->
              <select
                id="country"
                v-model="financeId"
                autocomplete="country"
                class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              >
                <option selected disabled>Choose Your Wallet</option>
                <option v-for="item in wallets" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="flex justify-end mt-6">
            <button
              class="px-6 py-2 leading-5 text-white transition-colors duration-200 transform bg-gray-400 rounded-md hover:bg-gray-700 focus:outline-none focus:bg-gray-400"
              @click.prevent="cancel"
            >
              Cancel
            </button>
            <button
              class="ml-2 px-6 py-2 leading-5 text-white transition-colors duration-200 transform bg-pink-400 rounded-md hover:bg-pink-700 focus:outline-none focus:bg-pink-400"
              @click.prevent="saveNewTransactions"
            >
              Save
            </button>
          </div>
        </form>
      </section>
    </transition>
    <transition name="fade">
      <div class="overflow-x-auto" v-show="!showForm">
        <div
          class="min-w-screen flex items-center justify-center font-sans overflow-hidden"
        >
          <div class="w-full lg:w-5/6">
            <div class="bg-white shadow-md rounded my-6">
              <table class="min-w-max w-full table-auto">
                <thead>
                  <tr
                    class="bg-gray-200 text-gray-600 uppercase text-sm leading-normal"
                  >
                    <th class="py-3 px-6 text-left">Wallet Name</th>
                    <th class="py-3 px-6 text-left">Created At</th>
                    <th class="py-3 px-6 text-center">Amount</th>
                    <th class="py-3 px-6 text-center">Status</th>
                    <th class="py-3 px-6 text-center">Actions</th>
                  </tr>
                </thead>
                <ListTransaction></ListTransaction>
              </table>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ListTransaction from "@/components/ListTransaction";
// import ListWalletName from "@/components/ListWalletName";
import { mapState } from "vuex";
export default {
  name: "AllTransactions",
  data() {
    return {
      showForm: false,
      amount: "",
      date: "",
      TransactionsType: "",
      financeId: "",
      error: false,
      success: false,
      graphic: true,
    };
  },
  components: {
    ListTransaction,
    // ListWalletName,
  },
  methods: {
    addNewTransactions() {
      this.graphic = false;
      this.error = false;
      this.showForm = true;
    },
    cancel() {
      this.showForm = false;
      this.graphic = true;
    },
    saveNewTransactions() {
      const { date, amount, TransactionsType, financeId } = this;
      if (
        date === "" ||
        amount === "" ||
        TransactionsType === "" ||
        financeId === ""
      ) {
        console.log(date, amount, TransactionsType, financeId);
        this.showForm = false;
        this.graphic = true;
        this.error = true;
        console.log("gagal");
      } else {
        this.showForm = false;
        this.graphic = true;
        this.success = true;
        const payload = {
          amount,
          date,
          TransactionsType,
          financeId,
        };
        this.amount = "";
        this.date = "";
        this.TransactionsType = "";
        this.financeId = "";
        this.$store.dispatch("addNewTransactions", payload);
      }
    },
    showFormTransactions() {
      this.showFormTransactions = true;
      this.graphic = true;
    },
    close() {
      this.success = false;
      this.graphic = true;
    },
  },
  computed: {
    ...mapState(["wallets", "dataSaldo"]),
  },
  created() {
    this.$store.dispatch("listTransactions");
    this.$store.dispatch("dataSaldo");
    this.$store.dispatch("fetchWallets");
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>